const { useEffect, useState } = require('react')
const { default: addressServices } = require('src/services/address.service')

// Lấy danh sách phường/xã từ ID huyện

const useWardsByProvinceId = (provinceId) => {
	const [wards, setWards] = useState(null)

	// get from ward
	useEffect(() => {
		if (!provinceId) return
		addressServices
			.queryWardsByProvinceId(provinceId)
			.then((response) => {
				if (!response.isError) setWards(response.wards)
			})
			.catch(console.log)
	}, [provinceId])

	return wards
}

export default useWardsByProvinceId
